"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cspKeys", {
  enumerable: true,
  get: function get() {
    return _apiKeys.cspKeys;
  }
});
exports.getClient = getClient;
exports.initHivemind = initHivemind;
var _auth = require("@exp/exp-utils/helper/auth");
var _visitor = require("@exp/exp-utils/helper/visitor");
var _hivemindCommon = require("@godaddy/hivemind-common");
var _hivemindClient = _interopRequireDefault(require("./hivemind-client"));
var _apiKeys = require("./api-keys");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var clients = {};
function initHivemind(_ref) {
  var Client = _ref.Client,
    app = _ref.app,
    env = _ref.env,
    shopperId = _ref.shopperId,
    visitorGuid = _ref.visitorGuid;
  var clientKey = "".concat(app).concat(env).concat(shopperId).concat(visitorGuid);
  if (!clients[clientKey]) {
    clients[clientKey] = new Client({
      app: app.replace(/\./g, '-'),
      cspKey: _apiKeys.cspKeys[env],
      subject: _objectSpread(_objectSpread({}, shopperId && _defineProperty({}, _hivemindCommon.hivemindConstants.idTypes.SHOPPER_ID, shopperId)), visitorGuid && _defineProperty({}, _hivemindCommon.hivemindConstants.idTypes.VISITOR_GUID, visitorGuid))
    });
  }
  return clients[clientKey].ready.then(function () {
    return clients[clientKey];
  });
}

// This factory function returns an initialized HivemindClient.
// It is *only* meant to be used in conjuction with the UXP headers where
// teams are setting `hivemind: true` in their request to Presentation Central
function getClient() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$Client = _ref4.Client,
    Client = _ref4$Client === void 0 ? _hivemindClient["default"] : _ref4$Client,
    _ref4$initClient = _ref4.initClient,
    initClient = _ref4$initClient === void 0 ? initHivemind : _ref4$initClient;
  var _window = window,
    _window$ux = _window.ux,
    _window$ux2 = _window$ux === void 0 ? {} : _window$ux,
    _window$ux2$data = _window$ux2.data,
    _window$ux2$data2 = _window$ux2$data === void 0 ? {} : _window$ux2$data,
    _window$ux2$data2$app = _window$ux2$data2.app,
    app = _window$ux2$data2$app === void 0 ? 'default' : _window$ux2$data2$app,
    _window$ux2$data2$env = _window$ux2$data2.env,
    env = _window$ux2$data2$env === void 0 ? 'dev' : _window$ux2$data2$env;
  (0, _auth.updateAuthTokens)();
  var shopperId = (0, _auth.getShopperId)();
  var visitorGuid = (0, _visitor.getVisitorId)();
  var initClientParams = {
    Client: Client,
    app: app,
    env: env,
    shopperId: shopperId,
    visitorGuid: visitorGuid
  };
  if (visitorGuid) {
    return initClient(initClientParams);
  } else {
    return new Promise(function (resolve) {
      window._expDataLayer.push({
        schema: 'get_tracking_values',
        version: 'v1',
        data: {
          callback: function callback(_ref5) {
            var visitorGuid = _ref5.vtg;
            initClientParams.visitorGuid = visitorGuid;
            resolve(initClient(initClientParams));
          }
        }
      });
    });
  }
}